export function isTruthy(input) {
    return !!input;
}
